import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Clock } from "lucide-react";

export default function TimePicker({ label, value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Fecha ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // horários de 30 em 30
  const times = Array.from({ length: 24 }, (_, h) =>
    ["00", "30"].map((m) => `${String(h).padStart(2, "0")}:${m}`)
  ).flat();

  const inputBaseClasses = `
    peer w-full h-10 px-2 border-b-[1px] border-gray-300
    focus:border-blue-600 focus:ring-0 focus:outline-none
    text-base text-gray-900 bg-transparent placeholder-transparent
    cursor-pointer
  `;

  const labelBaseClasses = (val) => `
    absolute left-2 transition-all duration-200 pointer-events-none
    ${val ? "-top-4 text-sm font-bold text-gray-900" : "top-2 text-base font-bold text-gray-500"}
    peer-focus:-top-4 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900
  `;

  return (
    <div className="relative w-28" ref={ref}>
      <input
        type="text"
        value={value}
        readOnly
        onClick={() => setOpen((p) => !p)}
        placeholder=" "
        className={inputBaseClasses}
      />
      <label className={labelBaseClasses(value)}>{label}</label>
      <Clock size={16} className="absolute right-6 top-3 text-gray-500" />
      <ChevronDown
        size={16}
        className={`absolute right-1 top-3 transition-transform ${open ? "rotate-180" : "rotate-0"}`}
      />

      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.2 }}
            className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-52 overflow-y-auto"
          >
            {times.map((t, i) => (
              <li
                key={i}
                onMouseDown={() => {
                  onChange(t);
                  setOpen(false);
                }}
                className="px-3 py-2 text-sm text-gray-700 hover:bg-blue-100 cursor-pointer"
              >
                {t}
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
